<template>
    <v-card :loading="data_loading">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                State
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                Cachement Size
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_9" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                LGA
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No of health workers
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_8" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Ward
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_7" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Medical Doctors
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_12" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Facility Type
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Midwives
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                Ownership
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Nurses
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_6" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Beds
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_11" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                        <div>
                            <h4 class="app-class-text-bold">
                                No Of Resident Doctors
                            </h4>
                            <p class="app-class-text-light">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_13" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentGeneralInfo',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
            data_loading: this.prop_submission==undefined || this.prop_submission.length == 0 ? true:false
        }
    },

    computed:{
        data_qst_1:function()
        {
            if(this.prop_submission!=undefined && this.prop_submission.length != 0)
            {
                if(this.prop_submission[0].qsts_all["GrpInformtn/FaciliName0"]!=undefined)
                {
                    return this.prop_submission[0].qsts_all["GrpInformtn/FaciliName0"]
                }
                else if(this.prop_submission[0].qsts_all["GrpInformtn/FacilitName"]!=undefined)
                {
                    return this.prop_submission[0].qsts_all["GrpInformtn/FacilitName"]
                }
                else if(this.prop_submission[0].qsts_all["GrpInformtn/otheFacName"]!=undefined)
                {
                    return this.prop_submission[0].qsts_all["GrpInformtn/otheFacName"]
                }
                else
                {
                    return undefined
                }
            }
        },
        data_qst_2:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/StateName00"];
        },
        data_qst_3:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/MedStaff000/MedstaffN025"];
        },
        data_qst_4:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/FacilityTyp"];
        },
        data_qst_5:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/LGAName0000"];
        },
        data_qst_6:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/MedStaff000/MedstaffN06"];
        },
        data_qst_7:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/WardName000"];
        },
        data_qst_8:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/NumbrStaffs"];
        },
        data_qst_9:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/TotalPopul0"];
        },
        data_qst_10:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/FacilityTyp"];
        },
        data_qst_11:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/NumberBeds0"];
        },
        data_qst_12:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/MedStaff000/MedstaffN01"];
        },
        data_qst_13:function()
        {
            return this.prop_submission==undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["GrpInformtn/MedStaff000/MedstaffN03"];
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
